import sdkPackage from "../../../plugins/sdk/package.json";

export const GRAMAX_SDK_VERSION = sdkPackage.version;
export const LEGACY_PLUGIN_MAX_SDK_VERSION = "0.1.0-alpha.12";
